import { Navigate } from "react-router-dom";
import { useAuth, roles } from "../context/AuthContext";

/**
 * Blocks logged-in users from reaching public-only pages (login, registration).
 *
 * The landing page differs per role:
 *  - Admin has a dashboard, so send them straight there. Sending admins to
 *    /events first caused a visible flash of the events page before the login
 *    handler navigated on to /dashboard.
 *  - Everyone else has no dashboard for now, so /events remains their home.
 */
const PublicOnlyRoute = ({ children }) => {
  const { isAuthenticated, role } = useAuth();

  if (!isAuthenticated) return children;

  // Fall back to sessionStorage: it is written before the auth state updates,
  // so this stays correct even on the first render after login or a refresh.
  const effectiveRole = role || sessionStorage.getItem("role");
  const redirectTo = effectiveRole === roles.ADMIN ? "/dashboard" : "/events";

  return <Navigate to={redirectTo} replace />;
};

export default PublicOnlyRoute;
